/* eslint-disable no-undef */
/* eslint-disable no-console */
import MediaRecord from '../../lib/media/media-record.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { createPortal } from 'react-dom';
import bindAll from 'lodash.bindall';
import TimeDown from './time-down.jsx';
import ShareModal from '../../containers/share-modal.jsx';
import RecordGuide from './record-guide.jsx';
import style, {audioItem, audioItemOn} from './media-record.css';
// import fixWebmDuration from '../../lib/fix-webm-duration.js';
import fixWebmMetaInfo from 'fix-webm-metainfo';
import swal2 from '../../lib/swal2';
import swal from '../../lib/swal';
import {scratchClick} from '../../utils/xes-analytice';
import {getDeviceStatus} from '../../utils';
import AliyunUploads from '../../lib/aliyun-oss/aliyun-upload.js';
import SparkMD5 from 'spark-md5';

class MediaRecordModal extends React.Component {
    constructor (props) {
        super(props);
        // this.setVideoRef = element => {
        //     this.videoRef = element;
        // };
        bindAll(this, [
            'handleVideoMouseDown',
            'handleTimeDownEnd',
            'handleStopRecord',
            'handleCloseShareModal',
            'startVideo',
            'handleAudioProcess',
            'timeDownEndCb',
            'onVisibilityChange',
            'handleRecordState',
            'onMouseDown',
            'toggleAudio',
            'toggleVideo',
            'setMainRef',
            'handleCancleRecord',
            'startUploadToAliyun',
            'calculateBlobMD5',
            'handleClearBlob',
            'handleReopenGuiShareModal'
        ]);
        this.classList = [];
        for (let i = 0; i < 5; i++) {
            this.classList.push(<div
                key={`voice_item${i}`}
                className={audioItem}
            />);
        }
        this.state = {
            timedown: true,
            recordState: 'init',
            stopCount: false,
            shareModalVisible: true,
            blob: null,
            volume: 0,
            guideShow: true,
            shareStatus: 'deviceDetectionStep',
            videoType: null,
            audioType: null,
            videoIniting: false,
            audioIniting: false,
            maxVideoLength: 300,
            process: 300,
            duration: 0,
            videoId: '',
            videoUrl: '',
            videoMd5: ''
        };
        this.aliyunUploader = null;
    }
    componentDidMount () {
        const {record} = this.props;
        const params = {
            video: record.video,
            audio: record.audio,
            screen: true
        };
        this.visibility(true);
        this.mediaRecorder = new MediaRecord(params);
        this.mediaRecorder.on('userstopedrecord', () => {
            this.handleStopRecord();
        });
        if (!this.mediaRecorder.detectRecord() || !this.mediaRecorder.detectMedia()) {
            this.props.onSetStopRecord();
            // eslint-disable-next-line react/no-did-mount-set-state
            swal.error('当前客户端暂不支持录制视频，建议使用Chrome浏览器访问小猴官网xiaohoucode.com进行录制。', false);
            return;
        }
        this.mediaRecorder.init().then(() => {
            this.setState({
                recordState: 'sharing',
                guideShow: false
            });
            this.mediaRecorder.on('audioprocess', this.handleAudioProcess);
            this.mediaRecorder.audioProcess();
        })
            .catch(error => {
                // eslint-disable-next-line no-console
                swal2.toast('录制功能启动失败');
                console.error('授权失败', error);
                const {onSetStopRecord} = this.props;
                onSetStopRecord();
            });
    }
    componentWillUnmount () {
        this.handleCancleRecord();
    }
    visibility (flag) {
        if (flag) {
            // eslint-disable-next-line no-nested-ternary
            this.hiddenProperty = 'hidden' in document ? 'hidden' :
                // eslint-disable-next-line no-nested-ternary
                'webkitHidden' in document ? 'webkitHidden' :
                    'mozHidden' in document ? 'mozHidden' : null;
            this.visibilityChangeEvent = this.hiddenProperty.replace(/hidden/i, 'visibilitychange');
            document.addEventListener(this.visibilityChangeEvent, this.onVisibilityChange);
            this.visibleStatus = true;
        } else {
            document.removeEventListener(this.visibilityChangeEvent, this.onVisibilityChange);
        }
    }
    onVisibilityChange () {
        if (document[this.hiddenProperty]) {
            if (this.visibleStatus) {
                this.visibleStatus = false;
                this.pauseRecord();
            }
        } else if (!this.visibleStatus) {
            this.visibleStatus = true;
            this.resumeRecord();
        }
    }
    pauseRecord () {
        if (this.mediaRecorder) {
            this.mediaRecorder.pauseRecord();
        }
    }
    resumeRecord () {
        if (this.mediaRecorder) {
            this.mediaRecorder.resumeRecord();
        }
    }
    // 创建 播放器显示摄像头

    handleVideoMouseDown (event) {
        const el = this.videoRef;
        const startX = event.clientX;
        const startY = event.clientY;
        const left = el.offsetLeft;
        const top = el.offsetTop;
        const clientWidth = document.body.clientWidth;
        const clientHeight = document.body.clientHeight;
        // eslint-disable-next-line no-shadow
        const moveFun = event => {
            const X = event.clientX - startX;
            const Y = event.clientY - startY;
            if ((left + X)>= -300 && (left + X + 20) <= clientWidth) el.style.left = `${left + X}px`;
            if ((top + Y) >= -220 && (top + Y + 20) <= clientHeight) el.style.top = `${top + Y}px`;
        };
        document.addEventListener('mousemove', moveFun);
        const removeFun = () => {
            document.removeEventListener('mousemove', moveFun);
            document.removeEventListener('mouseup', removeFun);
        };
        document.addEventListener('mouseup', removeFun);
    }

    handleTimeDownEnd () {
        this.setState({
            timedown: false
        }, this.timeDownEndCb);
    }

    timeDownEndCb () {
        setTimeout(() => {
            if (this.mediaRecorder) {
                this.mediaRecorder.startRecord().then(() => {
                    console.log('------- startRecord success --------');
                    this.videoStartTime = new Date().getTime();
                });
                this.run();
            }
        }, 100);
    }

    startVideo (videoType) {
        if (videoType && this.mediaRecorder && this.mediaRecorder.videoStream){
            this.videoRef.srcObject = this.mediaRecorder.videoStream;
            this.videoRef.onloadedmetadata = () => {
                if (this.videoRef) {
                    this.videoRef.play();
                }
            }
            this.videoRef.play();
            this.videoRef.style.display = 'block';
        }
    }

    // handleCountDownFinished () {
    //     this.handleStopRecord();
    // }

    handleStopRecord (showToast) {
        this.videoEndTime = new Date().getTime();
        const duration = (this.videoEndTime - this.videoStartTime) || 180;
        this.setState({duration: duration});
        if (showToast === 'click') {
            const {videoType, audioType} = this.state;
            scratchClick('click_xiaohou_share_step3', {
                language: 'Scratch',
                editor: 'Scratch编辑器',
                scene: '社区创作',
                bundle_id: '',
                question_id: '',
                video_duration: (duration / 1000).toFixed(1),
                status: getDeviceStatus(videoType, audioType)
            });
        }
        this.mediaRecorder.stopRecord().then(() => {
            
            this.mediaRecorder.getBlob().then(blob => {
              this.distoryVideo();
              fixWebmMetaInfo(blob, { type: 'video/webm\;codecs=h264' }).then((newBlob) => {
                    this.setState({
                        recordState: 'sharing',
                        stopCount: true,
                        blob: newBlob,
                        shareStatus: 'firstStep',
                    });
                    // 录制完成后，立即开始上传到阿里云（后台进行）
                    this.startUploadToAliyun(newBlob);
              });
              // fixWebmDuration(blob, duration, newBlob => {
              //     this.setState({
              //         recordState: 'sharing',
              //         stopCount: true,
              //         blob: newBlob,
              //         shareStatus: 'firstStep'
              //     });
              // });
            }).catch(()=>{
                // eslint-disable-next-line no-unused-expressions
                showToast && swal2.toast('录制失败，请退出重试');
                console.log('--------getBlob error--------');
            });
        }).catch(e => {
            // eslint-disable-next-line no-unused-expressions
            showToast && swal2.toast('录制失败，请退出重试');
            console.log(e, '--------stopRecord error--------');
        });
    }

    handleCloseShareModal () {
        const {onSetStopRecord} = this.props;
        this.setState({
            shareModalVisible: false
        });
        onSetStopRecord();
    }

    handleClearBlob () {
        this.setState({
            blob: null
        });
    }

    /**
     * 从录制分享流程中“重新上传”时，回到 GUI 层的 ShareModal（gui.jsx 190-197）
     * 1. 结束当前录制流程（隐藏 MediaRecordModal）
     * 2. 重新打开 GUI 的 ShareModal
     */
    handleReopenGuiShareModal () {
        const {onSetStopRecord, onOpenShareModal} = this.props;
        if (onSetStopRecord) {
            onSetStopRecord();
        }
        if (onOpenShareModal) {
            onOpenShareModal();
        }
    }

    handleAudioProcess (volume) {
        if (this.mediaRecorder) {
            this.setState({
                volume: volume
            });
        }
    }

    handleRecordState (type, video, audio){
        this.setState({
            videoType: video,
            audioType: audio
        });
        if (this.mediaRecorder) {
            if (!audio) {
                // this.mediaRecorder.stopStream('audio');
                this.mediaRecorder.setAudioTrackStatus(false)
                this.mediaRecorder.stopAudioProcess();
            }
            this.mediaRecorder.initRecorder();
        }
        this.setState({
            recordState: type
        });
        if (video) {
            this.creatVideo();
            this.startVideo(video);
        }
    }
    run () {
        const _this = this;
        const getProcessWidth = timestemp => {
            const {maxVideoLength} = _this.state;
            if (!_this.start) _this.start = timestemp;
            _this.speed = (timestemp - _this.start) / 1000;
            _this.processLineStyle = {};
            _this.processTimeStyle = {};
            _this.processLineStyle.width = `${(_this.speed / maxVideoLength) * 100}%`;
            if (_this.speed >= (maxVideoLength - 90)) {
                // _this.processLineStyle.backgroundColor = '#d25553';
                // _this.processTimeStyle.backgroundColor = '#d25553';
                _this.processTimeStyle.color = '#D25553';
            }
            _this.setState({process: maxVideoLength - parseInt(_this.speed, 10)});
            if (_this.speed <= maxVideoLength) {
                _this.processId = window.requestAnimationFrame(getProcessWidth);
            } else {
                _this.stopGetProcessWidth();
                _this.handleStopRecord(true);
            }
        };
        this.processId = window.requestAnimationFrame(getProcessWidth);
    }
    stopGetProcessWidth () {
        if (this.processId) window.cancelAnimationFrame(this.processId);
    }
    handleCancleRecord (){
        if (this.mediaRecorder) {
            this.mediaRecorder.distory();
            this.mediaRecorder = null;
        }
        // 取消上传
        if (this.aliyunUploader) {
            try {
                this.aliyunUploader.resetUpload();
            } catch (e) {
                console.log('重置阿里云上传失败', e);
            }
            this.aliyunUploader = null;
        }
        this.distoryVideo();
        this.visibility(false);
        this.stopGetProcessWidth();
        this.handleCloseShareModal();
    }

    /**
     * 计算 blob 的 MD5 值
     * @param {Blob} blob 要计算的文件 blob
     * @returns {Promise<string>} MD5 值
     */
    calculateBlobMD5 (blob) {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            const spark = new SparkMD5.ArrayBuffer();
            
            fileReader.onload = (e) => {
                spark.append(e.target.result);
                const md5 = spark.end();
                resolve(md5);
            };
            
            fileReader.onerror = (err) => {
                reject(err);
            };
            
            fileReader.readAsArrayBuffer(blob);
        });
    }

    /**
     * 开始上传到阿里云（后台进行，不显示上传界面）
     * @param {Blob} blob 要上传的视频 blob
     */
    startUploadToAliyun (blob) {
        if (!blob) {
            console.log('没有 blob，跳过上传');
            return;
        }

        // 如果上一次还没结束，先重置
        if (this.aliyunUploader) {
            try {
                this.aliyunUploader.resetUpload();
            } catch (e) {
                console.log('重置上一次阿里云上传失败', e);
            }
        }

        const self = this;
        const filename = `workflow_${Date.now()}.webm`;
        const title = Date.now();

        // 先计算 MD5
        this.calculateBlobMD5(blob).then(md5 => {
            console.log('视频 MD5:', md5);
            
            // 创建上传实例
            this.aliyunUploader = new AliyunUploads({
                events: {
                    addFileSuccess: function (uploadInfo) {
                        console.log('文件添加成功，开始上传', uploadInfo);
                    },
                    onUploadSucceed: function (uploadInfo) {
                        console.log('阿里云上传成功', uploadInfo);
                        
                        // 构建视频 URL
                        let videoUrl = '';
                        
                        // 方式1：直接使用 uploadInfo 中的 endpoint、bucket、object
                        if (uploadInfo.endpoint && uploadInfo.bucket && uploadInfo.object) {
                            const endpoint = uploadInfo.endpoint.replace(/^https?:\/\//, '');
                            const bucket = uploadInfo.bucket;
                            const object = uploadInfo.object;
                            videoUrl = `https://${bucket}.${endpoint}/${object}`;
                        }
                        // 方式2：解析 uploadAddress（base64 编码的 JSON）
                        else if (uploadInfo.uploadAddress) {
                            try {
                                const decodedStr = atob(uploadInfo.uploadAddress);
                                const addressInfo = JSON.parse(decodedStr);
                                
                                if (addressInfo.Endpoint && addressInfo.Bucket && addressInfo.FileName) {
                                    const endpoint = addressInfo.Endpoint.replace(/^https?:\/\//, '');
                                    const bucket = addressInfo.Bucket;
                                    const objectName = addressInfo.FileName;
                                    videoUrl = `https://${bucket}.${endpoint}/${objectName}`;
                                }
                            } catch (e) {
                                console.error('解析 uploadAddress 失败', e);
                            }
                        }
                        
                        // 保存上传结果到 state
                        self.setState({
                            videoId: uploadInfo.videoId || '',
                            videoUrl: videoUrl,
                            videoMd5: md5
                        });
                        
                        console.log('视频上传完成 - videoId:', uploadInfo.videoId, 'videoUrl:', videoUrl, 'md5:', md5);
                    },
                    onUploadFailed: function (uploadInfo, code, message) {
                        console.error('阿里云上传失败', uploadInfo, code, message);
                        // 上传失败不影响流程，只是没有提前获取到视频地址
                    },
                    onUploadProgress: function (uploadInfo, totalSize, progress) {
                        // 后台上传，不显示进度
                        console.log('阿里云上传进度', Math.floor(progress * 100) + '%');
                    }
                }
            });
            
            // 初始化并开始上传
            this.aliyunUploader.init();
            this.aliyunUploader.addBlobFile(blob, filename, title);
        }).catch(error => {
            console.error('计算 MD5 失败', error);
            // 即使 MD5 计算失败，也继续上传
            this.aliyunUploader = new AliyunUploads({
                events: {
                    onUploadSucceed: function (uploadInfo) {
                        let videoUrl = '';
                        if (uploadInfo.endpoint && uploadInfo.bucket && uploadInfo.object) {
                            const endpoint = uploadInfo.endpoint.replace(/^https?:\/\//, '');
                            const bucket = uploadInfo.bucket;
                            const object = uploadInfo.object;
                            videoUrl = `https://${bucket}.${endpoint}/${object}`;
                        } else if (uploadInfo.uploadAddress) {
                            try {
                                const decodedStr = atob(uploadInfo.uploadAddress);
                                const addressInfo = JSON.parse(decodedStr);
                                if (addressInfo.Endpoint && addressInfo.Bucket && addressInfo.FileName) {
                                    const endpoint = addressInfo.Endpoint.replace(/^https?:\/\//, '');
                                    const bucket = addressInfo.Bucket;
                                    const objectName = addressInfo.FileName;
                                    videoUrl = `https://${bucket}.${endpoint}/${objectName}`;
                                }
                            } catch (e) {
                                console.error('解析 uploadAddress 失败', e);
                            }
                        }
                        self.setState({
                            videoId: uploadInfo.videoId || '',
                            videoUrl: videoUrl,
                            videoMd5: ''
                        });
                    },
                    onUploadFailed: function (uploadInfo, code, message) {
                        console.error('阿里云上传失败', uploadInfo, code, message);
                    }
                }
            });
            this.aliyunUploader.init();
            this.aliyunUploader.addBlobFile(blob, filename, title);
        });
    }

    creatVideo () {
        if (!this.videoRef) {
            this.videoRef = document.createElement('video');
            this.videoRef.className = style.videoContainer;
            this.videoRef.onmousedown = this.handleVideoMouseDown;
            document.body.appendChild(this.videoRef);
        }
    }

    distoryVideo () {
        if (this.videoRef) {
            document.body.removeChild(this.videoRef);
            this.videoRef = null;
        }
    }

    onMouseDown (event) {
        const el = this.mainRef;
        const startX = event.clientX;
        const startY = event.clientY;
        const left = el.offsetLeft;
        const top = el.offsetTop;
        const offsetWidth = el.offsetWidth;
        const offsetHeight = el.offsetHeight;
        const clientWidth = document.body.clientWidth;
        const clientHeight = document.body.clientHeight;
        // eslint-disable-next-line no-shadow
        const moveFun = event => {
            const X = event.clientX - startX;
            const Y = event.clientY - startY;
            if ((left + X)>= -(offsetWidth - 24) && (left + X + 24) <= clientWidth) el.style.left = `${left + X}px`;
            if ((top + Y) >= -(offsetHeight - 12) && (top + Y + 12) <= clientHeight) el.style.top = `${top + Y}px`;
        };
        document.addEventListener('mousemove', moveFun);
        // document.body.style.overflow = 'hidden';
        const removeFun = () => {
            document.removeEventListener('mousemove', moveFun);
            document.removeEventListener('mouseup', removeFun);
            // document.body.style.overflow = 'auto';
        };
        document.addEventListener('mouseup', removeFun);
    }

    onMousePrevent (event) {
        event.preventDefault()
        event.stopPropagation()
    }

    setMainRef (ref) {
        this.mainRef = ref
    }

    toggleAudio() {
        const audioType = this.state.audioType
        const audioIniting = this.state.audioIniting
        if (audioIniting) return;
        if (!this.mediaRecorder) return;
        this.setState({
            audioIniting: true
        })
        try {
            if (!audioType) {
                this.mediaRecorder.setAudioTrackStatus(true)
                this.mediaRecorder.audioProcess()
                this.setState({
                    audioIniting: false
                })
            } else {
                this.mediaRecorder.setAudioTrackStatus(false)
                this.mediaRecorder.stopAudioProcess();
                this.setState({
                    audioIniting: false
                })
            }
            this.setState({
                audioType: !audioType
            })
        } catch (error) {
            this.setState({
                audioIniting: false
            })
            console.log('toggleVideoError', error)
        }
    }

    toggleVideo() {
        const videoType = this.state.videoType
        const videoIniting = this.state.videoIniting
        if (videoIniting) return;
        if (!this.mediaRecorder) return;
        this.setState({
            videoIniting: true
        })
        try {
            if (!videoType) {
                this.mediaRecorder.initVideo().then(() => {
                    this.creatVideo();
                    this.startVideo(true)
                    this.setState({
                        videoIniting: false
                    })
                });
            } else {
                this.mediaRecorder.stopStream('video');
                this.distoryVideo();
                this.setState({
                    videoIniting: false
                })
            }
            this.setState({
                videoType: !videoType
            })
        } catch (error) {
            this.setState({
                videoIniting: false
            })
            console.log('toggleVideoError', error)
        }
    }

    render () {
        const {timedown, recordState, stopCount, process, shareModalVisible, blob, volume, guideShow, shareStatus, videoType, audioType, duration} = this.state;
        // eslint-disable-next-line radix
        // const n = parseInt(volume * 100 / 2);
        // this.classList = this.classList.map((item, index) => {
        //     if (index <= n) {
        //         return (<div
        //             key={`voice_item${index}`}
        //             className={classNames(audioItem, audioItemOn)}
        //         />);
        //     }
        //     return (<div
        //         key={`voice_item${index}`}
        //         className={audioItem}
        //     />);
        // });
        const vHeight = volume * 5 * 16 + 'px'
        // console.log(volume, vHeight)
        return (
            createPortal(<div className={style.recordContainer} >
                {guideShow && <RecordGuide />}
                {recordState === 'recording' && timedown && <TimeDown onEnd={this.handleTimeDownEnd} />}
                {recordState === 'recording' && !timedown && <div className={style.recordBox} ref={this.setMainRef} onMouseDown={this.onMouseDown}>
                    <Fragment>
                        <div className={style.recordLeft} onMouseDown={this.onMousePrevent}>
                            <div className={classNames(style.audioState, audioType ? style.audioStateOn : '')} onClick={this.toggleAudio}>
                                <div className={style.audioVoice} style={{display: audioType ? 'block' : 'none'}}>
                                    <div className={style.audioVoiceHeight} style={{height: vHeight}}></div>
                                </div>
                            </div>
                            <div className={style.stateDivide}></div>
                            <div className={classNames(style.videoState, videoType ? style.videoStateOn : style.videoStateOff)} onClick={this.toggleVideo}/>
                        </div>
                        <div className={style.recordCenter}>
                            <div
                                style={this.processTimeStyle}
                                className={style.recordProcessTime}
                            >
                                <div className={style.numItem}>{parseInt(process / 600)}</div>
                                <div className={style.numItem}>{parseInt(process / 60) % 10}</div>
                                <div className={style.numDivide}>:</div>
                                <div className={style.numItem}>{parseInt(process % 60 / 10)}</div>
                                <div className={style.numItem}>{parseInt(process % 60 % 10)}</div>
                            </div>
                            <div className={style.mainTime}>{'总时长' + parseInt(this.state.maxVideoLength / 60) + 'min'}</div>
                        </div>
                        <div className={style.recordRight} onMouseDown={this.onMousePrevent}>
                            <button
                                onClick={this.handleCancleRecord}
                                className={classNames(style.button, style.buttonCancel)}
                            >{'不录了'}</button>
                            <button
                                className={classNames(style.button)}
                                // eslint-disable-next-line react/jsx-no-bind
                                onClick={() => this.handleStopRecord('click')}
                            >{'录制完成'}</button>
                        </div>
                    </Fragment>
                    {/* {!timedown && !stopCount && <CountDown
                        width={30}
                        height={30}
                        time={180}
                        onFinished={this.handleCountDownFinished}
                    />} */}
                </div>}
                {recordState === 'sharing' && shareModalVisible && <ShareModal
                    shareStatus={shareStatus}
                    blob={blob}
                    onCloseModal={this.handleCloseShareModal}
                    mediaRecorder={this.mediaRecorder}
                    volume={volume}
                    record={this.props.record}
                    onSetRecordState={this.handleRecordState}
                    duration={duration}
                    videoType={videoType}
                    audioType={audioType}
                    videoId={this.state.videoId}
                    videoUrl={this.state.videoUrl}
                    videoMd5={this.state.videoMd5}
                    onClearBlob={this.handleClearBlob}
                    onReopenGuiShareModal={this.handleReopenGuiShareModal}
                />}
            </div>, document.body)
        );
    }
}
MediaRecordModal.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    record: PropTypes.object,
    onSetStopRecord: PropTypes.func,
    onOpenShareModal: PropTypes.func
};

export default MediaRecordModal;
